var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLunc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.268 2.813c2.805-1.05 5.963-1.051 8.821-.189 3.72 1.155 6.86 3.963 8.502 7.487.452 1.005.886 2.052.93 3.168l.14.074c.195 1.46.336 2.947.077 4.408-.846-.358-1.562-.934-2.273-1.505-.175-.14-.348-.28-.524-.416-1.715-1.429-3.466-3.063-4.104-5.276a104.817 104.817 0 0 0-3.464-1.159c-2.57-.826-5.141-1.653-7.538-2.907a28.362 28.362 0 0 0-.265-.156c-.756-.44-1.6-.931-1.798-1.832-.088-.873.834-1.359 1.493-1.697zm-8.47 8.481c.813-2.204 2.145-4.25 3.954-5.766.46 3.783 2.07 7.439 4.73 10.189 3.188 3.313 7.73 5.347 12.352 5.27 1.576.05 3.122-.256 4.66-.56l.759-.149c-1.761 6.363-8.735 10.587-15.196 9.571-3.9-.5-7.501-2.809-9.674-6.07-2.451-3.602-3.07-8.387-1.584-12.486z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunc);
export default __webpack_public_path__ + "static/media/LUNC.4882871333b875eab86523a8b0482ce7.svg";
export { ForwardRef as ReactComponent };